import { FC } from 'react'

import {
  Button,
  Cluster,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  Typography,
} from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { SelectedSort } from '../hooks/NotificationSortContextProvider'
import { useNotificationSortContext } from '../hooks/useNotificationSortContext'

const sortOptions: SelectedSort[] = [
  { field: 'createdAt', direction: 'desc', key: 'newestFirst' },
  { field: 'typePriority', direction: 'desc', key: 'byPriority' },
]

export const NotificationsSorting: FC = () => {
  const { translate } = useLocalisation()
  const { sort, setSort } = useNotificationSortContext()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline-secondary">
          <Cluster gap={4} y="center">
            {translate('notifications.sort.sortBy')}{' '}
            <Typography color="primary">{translate(`notifications.sort.${sort.key}`)}</Typography> <Icon name="Sort" />
          </Cluster>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {sortOptions.map((sortOption) => (
          <DropdownMenuItem key={sortOption.key} onClick={() => setSort(sortOption)}>
            {translate(`notifications.sort.${sortOption.key}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
